import { QuestionnaireResponseItem } from 'fhir/r4b';
import { PHARMACY_COLLECTION_LINK_IDS } from '../../types/data/search-places';

export type PharmacyCollectionAnswerSetInput = {
  placesId: string;
  placesName: string;
  placesAddress: string;
  placesPhone: string | undefined;
  erxPharmacyId: string | undefined;
};

/**
 * configures pharmacy collection data (places search results) to the appropriate shape for intake paperwork
 * @param input: PharmacyCollectionAnswerSetInput
 * @returns QuestionnaireResponseItem[]
 */
export const makePharmacyCollectionAnswerSetForQR = ({
  placesId,
  placesName,
  placesAddress,
  placesPhone,
  erxPharmacyId,
}: PharmacyCollectionAnswerSetInput): QuestionnaireResponseItem[] => {
  const answerSet = [
    {
      linkId: PHARMACY_COLLECTION_LINK_IDS.placesId,
      answer: [{ valueString: placesId }],
    },
    {
      linkId: PHARMACY_COLLECTION_LINK_IDS.placesName,
      answer: [{ valueString: placesName }],
    },
    {
      linkId: PHARMACY_COLLECTION_LINK_IDS.placesAddress,
      answer: [{ valueString: placesAddress }],
    },
    {
      linkId: PHARMACY_COLLECTION_LINK_IDS.placesDataSaved,
      answer: [{ valueBoolean: true }],
    },
  ];

  if (placesPhone) {
    answerSet.push({
      linkId: PHARMACY_COLLECTION_LINK_IDS.placesPhone,
      answer: [{ valueString: placesPhone }],
    });
  }

  if (erxPharmacyId) {
    answerSet.push({
      linkId: PHARMACY_COLLECTION_LINK_IDS.erxPharmacyId,
      answer: [{ valueString: erxPharmacyId }],
    });
  }

  return answerSet;
};

/**
 * configures an array to clear out pharmacy collection data (places search results) from intake paperwork
 * @returns QuestionnaireResponseItem[]
 */
export const clearPharmacyCollectionAnswerSet = (): QuestionnaireResponseItem[] => {
  return [
    {
      linkId: PHARMACY_COLLECTION_LINK_IDS.placesId,
    },
    {
      linkId: PHARMACY_COLLECTION_LINK_IDS.placesName,
    },
    {
      linkId: PHARMACY_COLLECTION_LINK_IDS.placesAddress,
    },
    {
      linkId: PHARMACY_COLLECTION_LINK_IDS.placesPhone,
    },
    {
      linkId: PHARMACY_COLLECTION_LINK_IDS.placesDataSaved,
    },
    {
      linkId: PHARMACY_COLLECTION_LINK_IDS.erxPharmacyId,
    },
  ];
};
